export default "__VITE_ASSET__CZNW0wc5__"